// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// local
//  https://console.firebase.google.com
/*export const environment = {
  production: false,
  apiUrl: 'http://192.168.1.150/api/',
  imageUrl: 'http://192.168.1.150/',
  appUrl: 'http://localhost:4200',
  firebase: {
    apiKey: "AIzaSyAV8CJeqNtRTyJTbzbFHsIZnNFuUb5Jny8",
    authDomain: "justsmoke-60a29.firebaseapp.com",
    databaseURL: "https://justsmoke-60a29.firebaseio.com",
    projectId: "justsmoke-60a29",
    storageBucket: "justsmoke-60a29.appspot.com",
    messagingSenderId: "539606715764"
  },
  googleMapsKey: 'AIzaSyBXRd7SYJGrEXjuaOEWWGQEdRbEIbicQmU', // 'AIzaSyA8SDAzIChdp0gS-I3jC-_do4Nft3R-JV8',
};*/

// live
// https://console.firebase.google.com

//FOR LOCAL DEVELOPMENT
/* export const environment = {
  production: false,
  apiUrl:'http://localhost:8000/api/',
  imageUrl:'http://localhost:8000/',
  appUrl:'http://localhost:8000/booking',
  menuBannerImageUrl:'http://localhost:8000/restaurant_image/MenuBanner.jpg',
  matterportClientKey: "43endetwuhtb2frfure8yhcxc",
  firebase:{
    apiKey: "AIzaSyBYVKOGFoe5jyi3ZxlfZkMkvppu4TE1VnI",
    authDomain: "just-smoke-1537178641964.firebaseapp.com",
    databaseURL: "https://just-smoke-1537178641964.firebaseio.com",
    projectId: "just-smoke-1537178641964",
    storageBucket: "just-smoke-1537178641964.appspot.com",
    messagingSenderId: "1085083248012",
    appId: "1:1085083248012:web:d0fb523fb67c72b23c62a9"
  },

  googleMapsKey:'AIzaSyARh12rcI6GG5bSXRiqdosG1Y4kc1YNCSs',  //'AIzaSyA8SDAzIChdp0gS-I3jC-_do4Nft3R-JV8',
  paypal:{
    env:'sandbox', // sandbox | production
    client:{
      sandbox: 'AYLz3H3nbItj39ParEKMv5DW8GdSpWTuad9BCWvrs2SLOBwDsyCB3KCznXZNnVsXYWHtuzy177OxHCcB',
      production: '<insert production client id>'
    }
  }
}; */

//FOR SHISHATOURS DEV SERVER
export const environment = {
  production: false,
  apiUrl: 'https://venuetours.co.uk/api/',
  imageUrl: 'https://venuetours.co.uk/',
  appUrl: 'https://venuetours.co.uk/booking',
  menuBannerImageUrl:'https://venuetours.co.uk/restaurant_image/MenuBanner.jpg',
  matterportClientKey: "43endetwuhtb2frfure8yhcxc",
  firebase:{
    apiKey: "AIzaSyBmO9WLmUGGQAag69n-L19Qxe_JwC23ytI",
    authDomain: "venue-tours.firebaseapp.com",
    projectId: "venue-tours",
    storageBucket: "venue-tours.appspot.com",
    messagingSenderId: "807601882985",
    appId: "1:807601882985:web:d87ca138db444d702fdff8",
    measurementId: "G-8EN15PCJLV"
  },

  googleMapsKey:'AIzaSyARh12rcI6GG5bSXRiqdosG1Y4kc1YNCSs',  //'AIzaSyA8SDAzIChdp0gS-I3jC-_do4Nft3R-JV8',
  paypal:{
    env:'sandbox', // sandbox | production
    client:{
      sandbox: 'AYLz3H3nbItj39ParEKMv5DW8GdSpWTuad9BCWvrs2SLOBwDsyCB3KCznXZNnVsXYWHtuzy177OxHCcB',
      production: '<insert production client id>'
    }
  }
};

// FOR SHISHATOURS PROD SERVER
/* export const environment = {
  production: false,
  apiUrl: 'https://shishatours.co.uk/api/',
  imageUrl: 'https://shishatours.co.uk/',
  appUrl: 'https://shishatours.co.uk/booking',
  menuBannerImageUrl:'https://shishatours.co.uk/restaurant_image/MenuBanner.jpg',
  matterportClientKey: "43endetwuhtb2frfure8yhcxc",
  firebase:{
    apiKey: "AIzaSyBYVKOGFoe5jyi3ZxlfZkMkvppu4TE1VnI",
    authDomain: "just-smoke-1537178641964.firebaseapp.com",
    databaseURL: "https://just-smoke-1537178641964.firebaseio.com",
    projectId: "just-smoke-1537178641964",
    storageBucket: "just-smoke-1537178641964.appspot.com",
    messagingSenderId: "1085083248012",
    appId: "1:1085083248012:web:d0fb523fb67c72b23c62a9"
  },

  googleMapsKey:'AIzaSyARh12rcI6GG5bSXRiqdosG1Y4kc1YNCSs',  //'AIzaSyA8SDAzIChdp0gS-I3jC-_do4Nft3R-JV8',
  paypal:{
    env:'production', // sandbox | production
    client:{
      sandbox: 'AYLz3H3nbItj39ParEKMv5DW8GdSpWTuad9BCWvrs2SLOBwDsyCB3KCznXZNnVsXYWHtuzy177OxHCcB',
      production: 'AQ5XTN_c538Kr8slg22b6-6z4t9QvFtix-C4sUX49fQ-sBRzmIUtWVCNxN2f3kv3uL1ZuIB1mdiobQEw'
    }
  }
}; */

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
